export default __webpack_public_path__ + "e514f40d6d958114d7d4ec5d2464c047.svg";